import {BaseTabs} from '../../../application/baseTabs';
import {Api} from '../../../application/api/api';
import {LazyImages} from '../../../application/lazyLoad/lazyImages';

class Tabs extends BaseTabs
{
    initListeners() {
        Array.from(this.toggleButtons).forEach((element) => element.addEventListener('click', (event) => {
            event.preventDefault();
            let toggleButton = event.currentTarget;

            if (toggleButton.getAttribute('data-loaded')) {
                return this.activateTab(toggleButton);
            }

            if (toggleButton.getAttribute('data-load') === 'main') {
                toggleButton.setAttribute('data-loaded', 1);
                this.activateTab(toggleButton);
            } else {
                this.loadTabContent(toggleButton);
            }
        }));
    }

    /**
     * @param {Element|EventTarget} toggleButton
     */
    activateTab(toggleButton) {
        let activeTabContent = super.activateTab(toggleButton);
        this.container.querySelector('[data-tabs="header"]').innerHTML = activeTabContent.getAttribute('data-header');

        return activeTabContent;
    }

    /**
     * @param {Element|EventTarget} toggleButton
     */
    loadTabContent(toggleButton) {
        let tabName = toggleButton.getAttribute('data-load'),
            tabContent = this.container.querySelector(`[data-tabs="content"][data-load="${tabName}"]`);

        Api.post(toggleButton.getAttribute('data-endpoint'), {}, (response) => {
            if (response.isFailure()) {
                return false;
            }

            tabContent.querySelector('[data-content="list"]').innerHTML = response.get('content', '');
            tabContent.setAttribute('data-loaded', 1);
            LazyImages.load();

            this.activateTab(toggleButton);
        });
    }
}

export {Tabs};
